import { render } from "./HeroiconsSolidSwitchVertical.vue?vue&type=template&id=3c46c48c"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSwitchVertical.vue"]])

export default __exports__